import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GetApplicationsMarathonCorporateIssuanceParams,
  GetApplicationsMarathonCorporateIssuanceResponse,
} from "api/api/applicationsApi/types";

export const getApplicationsMarathonCorporateIssuance = createAsyncThunk<
  GetApplicationsMarathonCorporateIssuanceResponse,
  GetApplicationsMarathonCorporateIssuanceParams
>(
  "applications/getApplicationsMarathonCorporateIssuance",
  async ({ marathonId, corporateClientId, ...params }, { rejectWithValue }) => {
    try {
      const data =
        await ApplicationsAPI.getApplicationsMarathonCorporateIssuance({
          marathonId,
          corporateClientId,
          ...params,
        });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting applications marathon corporate issuance",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error(
          "Error while getting applications marathon corporate issuance",
          error
        );
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
